module.exports = __webpack_public_path__ + "static/media/portfolio6.709c74a5.png";